import { ColorRecipeModel } from './color-recipe.model';

export class PaintPresetModel { 
    constructor(
        public label: string,
        public recipe: ColorRecipeModel,
        public icon: string = '_color',
        public group: string
    ) { }
}
